import { ChatAction } from "../../../http";

export const isTableLine = (line: string): boolean =>
  line.trim().startsWith("|") || line.includes("\t");

export const parseActionsFromText = (raw: string): { text: string; actions: ChatAction[] } => {
  const idx = raw.indexOf("ACTIONS:");
  if (idx === -1) return { text: raw, actions: [] };
  const text = raw.slice(0, idx).trimEnd();
  const actionLines = raw.slice(idx + 8).trim().split("\n").filter(Boolean);
  const actions: ChatAction[] = actionLines
    .map((line) => {
      const [actionKey, ...rest] = line.split("|");
      return { actionKey: actionKey.trim(), label: rest.join("|").trim() };
    })
    .filter((a) => a.actionKey && a.label);
  return { text, actions };
};
